import type {Article} from '@/model/Article';

export type KeywordWorkspaceTableLockInput = {
    sharePreview: boolean;
    enhancingOverride: boolean;
    articleMetadata: Article;
    keywordSelectionShown: boolean;
    readOnly: boolean;
};

/** When true, KeywordsList / KeywordTopicChips Lucy controls are read-only. */
export function isKeywordWorkspaceTableLocked(input: KeywordWorkspaceTableLockInput): boolean {
    const {sharePreview, enhancingOverride} = input;
    if (sharePreview || enhancingOverride) {
        return true;
    }
    return false;
}
